// ── Judge.me brand color override (JS beats dynamically-injected CSS) ──
(function () {
  var RED = '#c0002a';
  function set(el, prop) { el.style.setProperty(prop, RED, 'important'); }

  function applyJudgeMeColors() {
    document.querySelectorAll('.jdgm-histogram__bar-val').forEach(function (el) {
      set(el, 'background-color'); set(el, 'background');
    });
    document.querySelectorAll('.jdgm-badge-verified').forEach(function (el) {
      set(el, 'background-color'); set(el, 'background'); set(el, 'border-color');
    });
    // Sort dropdown text (custom dropdown or native select)
    document.querySelectorAll('.jdgm-dd__selected, .jdgm-rev-widg__sort a, .jdgm-rev-widg__sort select').forEach(function (el) {
      set(el, 'color');
    });
    // "Verified" link below badges
    document.querySelectorAll('.jdgm-verified-info a').forEach(function (el) {
      el.style.setProperty('color', '#999', 'important');
    });
  }

  var jdgmTimer = null;
  var observer = new MutationObserver(function () {
    clearTimeout(jdgmTimer);
    jdgmTimer = setTimeout(applyJudgeMeColors, 80);
  });

  function startJudgeMePatch() {
    observer.observe(document.body, { childList: true, subtree: true });
    applyJudgeMeColors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startJudgeMePatch);
  } else {
    startJudgeMePatch();
  }
})();

(function () {
  // ── Shrink header + shop tabs on scroll ──
  var header = document.querySelector('.header');
  if (header) {
    var ticking = false;
    function updateCompact() {
      var compact = window.scrollY > 60;
      header.classList.toggle('rsg-compact', compact);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(updateCompact); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', updateCompact);
    updateCompact();
  }

  // Only activate on desktop
  var mq = window.matchMedia('(min-width: 990px)');
  if (!mq.matches) return;

  function getHeaderBottom() {
    var group = document.querySelector('.shopify-section-group--header-group');
    if (group) return group.getBoundingClientRect().bottom;
    var wrapper = document.querySelector('.header__outer-wrapper') || document.querySelector('.header');
    if (!wrapper) return 80;
    return wrapper.getBoundingClientRect().bottom;
  }

  function positionFullWidth(submenu) {
    if (!submenu || submenu.dataset.depth !== '1') return;
    submenu.style.position = 'fixed';
    submenu.style.left = '0';
    submenu.style.width = '100vw';
    submenu.style.transform = 'none';
    submenu.style.marginTop = '0';
    submenu.style.top = getHeaderBottom() + 'px';
  }

  // Reposition all open depth-1 submenus on scroll (header height changes on compact)
  var scrollTicking = false;
  window.addEventListener('scroll', function () {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(function () {
      document.querySelectorAll('.navigation__submenu[data-depth="1"].active').forEach(positionFullWidth);
      scrollTicking = false;
    });
  }, { passive: true });

  function attachHoverBehavior(parent, submenu, trigger) {
    var closingByHover = false;
    var closeTimer = null;

    function cancelClose() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    }

    function scheduleClose() {
      cancelClose();
      closeTimer = setTimeout(function () {
        if (submenu.classList.contains('active')) {
          closingByHover = true;
          trigger.click();
          closingByHover = false;
        }
        closeTimer = null;
      }, 150);
    }

    // Block click from closing — only hover-away should close
    trigger.addEventListener('click', function (e) {
      if (submenu.classList.contains('active') && !closingByHover) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    }, true);

    // Hover open
    parent.addEventListener('mouseenter', function () {
      cancelClose();
      if (!submenu.classList.contains('active')) {
        trigger.click();
      }
      positionFullWidth(submenu);
    });

    // Schedule close when leaving; cancel if mouse enters the dropdown
    parent.addEventListener('mouseleave', scheduleClose);
    submenu.addEventListener('mouseenter', cancelClose);
    submenu.addEventListener('mouseleave', scheduleClose);
  }

  function init() {
    // Depth-1: top-level nav items with [data-submenu-parent]
    document.querySelectorAll('[data-submenu-parent]').forEach(function (parent) {
      var submenu = parent.querySelector('[data-submenu]');
      var trigger = parent.querySelector('[data-parent]');
      if (!submenu || !trigger) return;
      attachHoverBehavior(parent, submenu, trigger);
    });

    // Depth-2: items inside a depth-1 submenu that have their own sub-menu
    // These are .navigation__submenu-item elements — no [data-submenu-parent] on them
    document.querySelectorAll('.navigation__submenu[data-depth="1"] > .navigation__submenu-item').forEach(function (item) {
      var submenu = item.querySelector('[data-submenu]');
      var trigger = item.querySelector('[data-parent]');
      if (!submenu || !trigger) return;
      attachHoverBehavior(item, submenu, trigger);
    });

    mq.addEventListener('change', function (e) {
      if (!e.matches) {
        document.querySelectorAll('[data-submenu]').forEach(function (s) {
          s.style.position = '';
          s.style.left = '';
          s.style.width = '';
          s.style.transform = '';
          s.style.top = '';
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
